export const ONBOARDING_STAGES = ['Documentation', 'ContractSigning', 'Training', 'Verification', 'Complete'];
export const CONTRACT_TYPES = ['Permanent', 'FixedTerm', 'PartTime', 'Seasonal', 'IndependentContractor'];
export const EMPLOYMENT_STATUS = ['Pending', 'Active', 'Suspended', 'OnProbation', 'Terminated'];

export const STATUS_COLORS: Record<string, string> = {
  Pending: 'warning',
  Active: 'success',
  Suspended: 'error',
  OnProbation: 'info',
  Terminated: 'default',
};

export const STAGE_COLORS: Record<string, string> = {
  Documentation: 'info',
  ContractSigning: 'warning',
  Training: 'primary',
  Verification: 'secondary',
  Complete: 'success',
};

export const TRAINING_STATUS_COLORS: Record<string, string> = {
  Planned: 'default',
  InProgress: 'info',
  Completed: 'success',
  NotCompleted: 'warning',
  Cancelled: 'error',
};

export const CASE_STAGE_COLORS: Record<string, string> = {
  Investigation: 'warning',
  Hearing: 'info',
  Appeal: 'secondary',
  Closed: 'success',
};

export interface EmployeeRecord {
  id?: string;
  status?: string;
  legalEntity?: { type: string; id: string; firstName?: string; lastName?: string; email?: string; phone?: string; idNumber?: string };
  employeeNumber?: string;
  seniority?: { jobTitle?: string; occupationalLevel?: string };
  organisationalHierarchy?: { department?: string };
  contractType?: string;
  employmentTerms?: { startDate?: string };
  probationDetails?: { endDate?: string };
  demographics?: { gender?: string; race?: string };
  [key: string]: unknown;
}

export interface FileRecord {
  id?: string;
  mimeType?: string;
  fileName?: string;
  documentType?: string;
  subsystem?: string;
  size?: number;
  status?: string;
  legislation?: { sensitivityLevel?: string };
  metadata?: { createdAt?: string };
  [key: string]: unknown;
}
